<template>
    <v-container fluid px-4 py-0 pt-1 grid-list-lg>
        <v-layout row wrap>
            <v-flex xs12></v-flex>
            <v-flex xs12>
                <h3>Reports</h3>
                <v-layout row wrap>
                    <v-flex xs12 md3>
                        <v-btn class="btn btn-primary" @click="navigateDateRangeReport">Date Range Totals Report</v-btn>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-btn class="btn btn-primary" @click="navigateYTDReport">Year To Date Report</v-btn>
                    </v-flex>
                    <v-flex xs12 md3>
                        <v-btn class="btn btn-primary" @click="navigateNonJurisdictionalReport">Non Jurisdictional Report</v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

export default {
    mounted () {
    },
    methods: {
        navigateDateRangeReport () {
            this.$router.push('/daterangetotalsreport/')
        },
        navigateYTDReport () {
            this.$router.push('/yeartodatereport/')
        },
        navigateNonJurisdictionalReport () {
            this.$router.push('nonjurisdictionalreport/')
        }
    }
}
</script>
